/* eslint no-param-reassign: 0 */
import * as types from '../mutation-types';
import SupabaseAPI from '../../api/supabase';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const state = {
  config: null,
  uiFlags: {
    isFetching: false,
    isUpdating: false,
    isTesting: false,
  },
};

export const getters = {
  getConfig: $state => $state.config,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.default.SET_SUPABASE_UI_FLAG, { isFetching: true });
    try {
      const { data } = await SupabaseAPI.show();
      commit(types.default.SET_SUPABASE_CONFIG, data.config);
    } catch (error) {
      commit(types.default.SET_SUPABASE_CONFIG, null);
    } finally {
      commit(types.default.SET_SUPABASE_UI_FLAG, { isFetching: false });
    }
  },
  save: async ({ commit }, payload) => {
    commit(types.default.SET_SUPABASE_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await SupabaseAPI.save(payload);
      commit(types.default.SET_SUPABASE_CONFIG, data.config);
      return data.config;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.default.SET_SUPABASE_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }) => {
    commit(types.default.SET_SUPABASE_UI_FLAG, { isUpdating: true });
    try {
      await SupabaseAPI.delete();
      commit(types.default.SET_SUPABASE_CONFIG, null);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.default.SET_SUPABASE_UI_FLAG, { isUpdating: false });
    }
  },
  testConnection: async ({ commit }) => {
    commit(types.default.SET_SUPABASE_UI_FLAG, { isTesting: true });
    try {
      const { data } = await SupabaseAPI.testConnection();
      return data;
    } catch (error) {
      throwErrorMessage(error);
      return { success: false };
    } finally {
      commit(types.default.SET_SUPABASE_UI_FLAG, { isTesting: false });
    }
  },
};

export const mutations = {
  [types.default.SET_SUPABASE_UI_FLAG]($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  [types.default.SET_SUPABASE_CONFIG]($state, config) {
    $state.config = config;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
